import { z } from 'zod';
import { RECORD_REQUEST_STATUS } from '../enums';
export const codingSchema = z.object({
    encounterId: z.string().uuid().nullable().optional(),
    admissionId: z.string().uuid().nullable().optional(),
    diagnoses: z
        .array(z.object({
        icdCode: z.string().trim().min(1).max(16),
        description: z.string().trim().max(300).optional(),
        isPrimary: z.boolean().default(false),
    }))
        .min(1)
        .max(30),
});
export const recordRequestSchema = z.object({
    patientId: z.string().uuid(),
    requestedBy: z.string().trim().min(2).max(160),
    requesterType: z.enum(['patient', 'relative', 'legal', 'insurer', 'internal']).default('patient'),
    purpose: z.string().trim().min(3).max(600),
    /** Reference to the signed consent; releasing without one is refused. */
    consentRef: z.string().trim().max(160).optional(),
    notes: z.string().max(2000).optional(),
});
export const recordReleaseSchema = z.object({
    status: z.enum(RECORD_REQUEST_STATUS),
    consentRef: z.string().trim().max(160).optional(),
    notes: z.string().max(2000).optional(),
});
// ── Custom report builder (SRS 10.4) ─────────────────────────────────────────
/**
 * Datasets the builder may query. Whitelisted deliberately: a builder that can
 * name any table is an unbounded read of the clinical record.
 */
export const REPORT_DATASETS = [
    'invoices',
    'payments',
    'encounters',
    'appointments',
    'admissions',
    'lab_orders',
    'pharmacy_sales',
    'claims',
];
export const reportFilterSchema = z.object({
    field: z.string().trim().min(1).max(60),
    op: z.enum(['eq', 'ne', 'gt', 'gte', 'lt', 'lte', 'in', 'contains']),
    value: z.union([z.string(), z.number(), z.boolean(), z.array(z.union([z.string(), z.number()]))]),
});
export const reportDefinitionSchema = z.object({
    dataset: z.enum(REPORT_DATASETS),
    fields: z.array(z.string().trim().min(1).max(60)).min(1).max(30),
    filters: z.array(reportFilterSchema).max(20).default([]),
    groupBy: z.array(z.string().trim().min(1).max(60)).max(4).default([]),
    aggregates: z
        .array(z.object({
        field: z.string().trim().min(1).max(60),
        fn: z.enum(['count', 'sum', 'avg', 'min', 'max']),
        alias: z.string().trim().max(60).optional(),
    }))
        .max(10)
        .default([]),
    orderBy: z.string().trim().max(60).optional(),
    orderDir: z.enum(['asc', 'desc']).default('desc'),
    limit: z.number().int().min(1).max(5000).default(200),
    /** Date window applied to the dataset's own date column. */
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
});
export const saveReportSchema = z.object({
    code: z.string().trim().toUpperCase().min(2).max(40),
    name: z.string().trim().min(2).max(160),
    definition: reportDefinitionSchema,
    sharedWithRoleIds: z.array(z.string().uuid()).max(50).default([]),
    schedule: z.string().trim().max(60).nullable().optional(),
    recipients: z.array(z.string().trim().max(160)).max(50).default([]),
});
//# sourceMappingURL=mrd.js.map